export const getBehaviourFuelSavingsOverTimeRespAviation = () => {
  return {
    baseline: {
      value: 65.504494,
      standardError68: 0.057023,
      standardError95: 0.11176509,
    },
    periods: [
      {
        timestamp: 1696118400000,
        countEventsPerformable: 10179,
        countEventsPerformed: 10179,
        value: {
          value: 67.9,
          standardError68: 0.2,
          standardError95: 0.4,
        },
        valueChangeFromBaseline: {
          value: 2.4,
          standardError68: 0.2,
          standardError95: 0.5,
        },
      },
      {
        timestamp: 1698796800000,
        countEventsPerformable: 7736,
        countEventsPerformed: 7736,
        value: {
          value: 67,
          standardError68: 0.2,
          standardError95: 0.5,
        },
        valueChangeFromBaseline: {
          value: 2.1,
          standardError68: 0.2,
          standardError95: 0.5,
        },
      },
      {
        timestamp: 1701388800000,
        countEventsPerformable: 7726,
        countEventsPerformed: 7726,
        value: {
          value: 70.8,
          standardError68: 0.3,
          standardError95: 0.5,
        },
        valueChangeFromBaseline: {
          value: 5.3,
          standardError68: 0.3,
          standardError95: 0.5,
        },
      },
    ],
  };
};
